import React from 'react';

const Appointments = React.lazy(() => import('pages/Appointments/Appointments'));
const AppointmentsAdd = React.lazy(() => import('pages/Appointments/AppointmentsAdd'));
const AppointmentsEdit = React.lazy(() => import('pages/Appointments/AppointmentsEdit'));
const AppointmentsDetail = React.lazy(() => import('pages/Appointments/AppointmentsDetail'));

const appointmentsRoutes = [
  {
    path: '/appointment',
    exact: true,
    name: 'Danh sách đặt lịch',
    function: 'APPOINTMENTS_VIEW',
    component: Appointments,
  },
  {
    path: '/appointment/add',
    exact: true,
    name: 'Thêm mới đặt lịch',
    function: 'APPOINTMENTS_ADD',
    component: AppointmentsAdd,
  },
  {
    path: '/appointment/detail/:id',
    exact: true,
    name: 'Chi tiết đặt lịch',
    function: 'APPOINTMENTS_VIEW',
    component: AppointmentsDetail,
  },
  {
    path: '/appointment/edit/:id',
    exact: true,
    name: 'Chỉnh sửa đặt lịch',
    function: 'APPOINTMENTS_EDIT',
    component: AppointmentsEdit,
  },
];

export default appointmentsRoutes;
